import React from 'react';

import {TopBarButton} from './form/FormElements';
import config from '../config';

const openInNewTab = url => {
  var win = window.open(url, '_blank');
  win.focus();
};

const download = () => {
  const href = `${config.apiUrl}/download/cedocument/general?authToken=${config.getPlainAuthToken()}`;
  openInNewTab(href);
};
const CEDownload = () => <TopBarButton onClick={download} label="Leistungserklärung" />;
export default CEDownload;



// WEBPACK FOOTER //
// ./src/components/CEDownload.js